import Http from './base';
import { BASE_URL, OFFERS } from './base/constants';

class OffersService {
  get(params) {
    const { id, page = 1 } = params;
    return Http.get(`${BASE_URL}${OFFERS}/${id}`, {
      params: { page: page - 1 }
    });
  }
}

export default new OffersService();
